import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faSpinner } from "@fortawesome/free-solid-svg-icons";
import CopyUrl from "../../../components/athlete-scores/share-profile/copy-url";
import CircularProgressBar from "../../../components/CircularProgressBar";

export default function AthleteInfo({
  athleteData,
  userAthlete,
  loadingPhoto,
  onPhotoUpload,
}) {
  return (
    <>
      {loadingPhoto && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/50">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="3x"
            className="text-white"
          />
          <p className="mt-4 text-white text-lg font-medium">
            Uploading photo…
          </p>
        </div>
      )}
      <div className="flex justify-between items-center pb-4 mb-1">
        <div className="flex flex-row text-xl uppercase flex-1">
          <div className="relative my-auto rounded-lg">
            <img
              alt="Athlete Name"
              src={athleteData.profilePicture || "/default-profile-img.png"}
              className="grow-0 shrink-0 rounded-lg object-cover h-[110px] w-[100px]"
            />

            <button
              onClick={onPhotoUpload}
              className="absolute bottom-[-10px] right-0 bg-white shadow-lg rounded-full border-gray-300 text-blue-500 text-sm p-2 px-3"
              disabled={loadingPhoto}
            >
              <FontAwesomeIcon icon={faUpload} alt=" Upload photos" />
            </button>
          </div>
          <div className="ml-4">
            <p className="text-lg font-medium uppercase text-gray-900 flex items-center gap-2 whitespace-nowrap">
              <span>
                {athleteData.firstName} {athleteData.lastName} (
                {athleteData.age})
              </span>
              <CopyUrl athleteProfileId={athleteData.id} />
            </p>
            <div className="block">
              <p className="text-gray-600 text-sm">{athleteData.position}</p>
              <p className="text-gray-600 text-sm">
                {athleteData.highSchool} ({athleteData.expectedYearOfGraduation}
                )
              </p>
              <p className="text-gray-600 text-sm">
                <span>{athleteData.primaryPosition}</span>
                <span>{athleteData.secondaryPosition}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="my-auto flex flex-col items-center">
          <CircularProgressBar
            progress={
              athleteData?.positionScore ?? userAthlete?.positionScore ?? 0
            }
            size={80}
            strokeWidth={5}
            color="#1C4ED8"
          />
          <span className="text-[9px] text-gray-900 -mt-8">Position Score</span>
        </div>
      </div>
    </>
  );
}
